if (!customElements.get('dgv-catalog-menu')) {
  customElements.define('dgv-catalog-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = [...this.querySelectorAll('[data-catalog-tab]')];
      this.panels = [...this.querySelectorAll('[role="region"]')];
      this.disclosure = this.closest('details');
      const mainMenu = this.closest('main-menu');
      if (!mainMenu.dataset.dgvNavigation) {
        mainMenu.dataset.dgvNavigation = 'true';
        const originalOpen = mainMenu.openMenuFromMouseEnter.bind(mainMenu);
        const originalClose = mainMenu.handleClose.bind(mainMenu);
        mainMenu.openMenuFromMouseEnter = (trigger) => {
          clearTimeout(mainMenu.menuLinkTimeout);
          clearTimeout(mainMenu.singleLinkTimeout);
          const disclosure = trigger.closest('details');
          const active = mainMenu.nav.querySelector('details.is-open');
          if (active && active !== disclosure) mainMenu.close(active, false);
          mainMenu.opener = trigger;
          originalOpen(trigger);
          mainMenu.toggleOverlay(true);
        };
        mainMenu.handleClose = (event) => {
          if (event && event.type === 'keyup' && event.key !== 'Escape') return;
          clearTimeout(mainMenu.menuLinkTimeout);
          clearTimeout(mainMenu.singleLinkTimeout);
          originalClose(event);
        };
        mainMenu.addEventListener('click', (event) => {
          const trigger = event.target.closest('summary.dgv-nav-toggle');
          if (!trigger || !window.matchMedia('(min-width: 769px)').matches) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const disclosure = trigger.parentElement;
          if (disclosure.classList.contains('is-open')) mainMenu.handleClose();
          else mainMenu.openMenuFromMouseEnter(trigger);
        }, true);
        window.matchMedia('(min-width: 1400px)').addEventListener('change', () => mainMenu.handleClose());
      }
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index), options);
        tab.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(this.hoverTimer);
          this.hoverTimer = setTimeout(() => {
            if (!this.querySelector('.dgv-catalog__panels').contains(document.activeElement)) this.activate(index);
          }, 110);
        }, options);
        tab.addEventListener('pointerleave', () => clearTimeout(this.hoverTimer), options);
        tab.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.panels[index].querySelector('a')?.focus();
            return;
          } else return;
          event.preventDefault();
          this.activate(next);
          this.tabs[next].focus();
        }, options);
      });
      this.querySelector('.dgv-catalog__close').addEventListener('click', () => this.close(), options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          this.close();
        }
      }, options);
      this.disclosure.addEventListener('toggle', () => {
        if (this.disclosure.open) this.fit();
      }, options);
      window.addEventListener('resize', () => this.fit(), options);
      this.classList.add('is-ready');
      this.fit();
    }
    activate(index) {
      clearTimeout(this.hoverTimer);
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-expanded', String(i === index));
        this.panels[i].hidden = i !== index;
      });
      this.querySelector('.dgv-catalog__panels').scrollTop = 0;
    }
    fit() {
      if (!this.disclosure.open) return;
      const top = this.querySelector('.dgv-catalog__body').getBoundingClientRect().top;
      this.style.setProperty('--dgv-catalog-space', Math.max(180, window.innerHeight - top - 70) + 'px');
    }
    close() {
      clearTimeout(this.hoverTimer);
      const menu = this.closest('main-menu');
      if (menu && typeof menu.handleClose === 'function') menu.handleClose();
      else {
        this.disclosure.classList.remove('is-open');
        this.disclosure.open = false;
      }
      this.disclosure.querySelector(':scope > summary').focus();
    }
    disconnectedCallback() {
      clearTimeout(this.hoverTimer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}

